import { render, staticRenderFns } from "./replacement.vue?vue&type=template&id=438e07b9&scoped=true&"
import script from "./replacement.vue?vue&type=script&lang=js&"
export * from "./replacement.vue?vue&type=script&lang=js&"
import style0 from "./replacement.vue?vue&type=style&index=0&id=438e07b9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e07b9",
  null
  
)

export default component.exports